<template>
  <div id="search-tracklist">
    <ul class="tracklist-list">
      <li
        v-for="(track, index) in tracklist"
        :key="`${index}-${track.permlink}`"
        class="tracklist-list__item"
      >
        <router-link :to="{ name: 'Show', params: { id: track.permlink } }">
          <div class="track">
            <div class="track__col">
              <div class="track__col__text">
                {{ formatIndex(index) }}
              </div>
            </div>
            <div class="track__col">
              <div class="track__col__heading">
                {{ track.artistName }}
              </div>
              <div class="track__col__text">
                {{ track.trackName }}
              </div>
            </div>
            <div class="track__col">
              <div class="track__col__heading">
                from the episode
              </div>
              <div class="track__col__text">
                {{ track.episodeName }}
              </div>
            </div>
            <div class="track__col">
              <div class="track__col__text">
                {{ formatDate(track.sqlDate) }}
              </div>
            </div>
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'SearchTracklist',
  props: {
    tracklist: {
      type: Array,
      required: true
    }
  },
  methods: {
    formatDate(date) {
      return date
        .split('-')
        .reverse()
        .join('.');
    },
    formatIndex(index){
         return Number.parseInt(index + 1).toString().padStart(2, '0');
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/abstracts/_variables.scss';
.tracklist-list {
  list-style: none;
  padding: 0;
  margin: 0;
  &__item {
    border-top: 1px solid $c_border_grey;
    border-bottom: unset;
    &:last-child {
      border-bottom: 1px solid $c_border_grey;
    }
    a {
      padding: 10px 0;
      display: block;
      &:hover {
        background-color: $c_base;
        div {
        color: $c_white;
        }
      }
    }
  }
}
.track {
  display: flex;
  &__col {
    &:nth-child(1) {
      width: 30px;
      padding-left: 10px;
    }
    &:nth-child(2) {
      flex: 1 0 33.333%;
      padding-right: 5px;
    }
    &:nth-child(3) {
      flex: 0 0 33.333%;
      padding-right: 5px;
      @include media-breakpoint-down(md) {
        display: none;
      }
    }
    &:nth-child(4) {
      flex: 1;
    }
    display: flex;
    flex-flow: column;
    &__heading {
      @include font-12-md;
      color: $c_black;
      text-transform: uppercase;
    }
    &__text {
      @include font-12;
      color: $c_medium_grey;
      text-transform: capitalize;
    }
  }
}
</style>
